import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useTransfer } from '../../../utils/service/service_transfer_api';
import css from '../../../styles/modules/PaymentSummary/paymentdetails.module.css';
import CardHeader from '../Components/PaymentDetailsComponents/CardHeader';
import ProgressAndDollar from '../Components/PaymentDetailsComponents/ProgressAndDollar';
import ExpandableSections from '../../ExpandableSections/ExpandableSections';
import Details from '../Components/PaymentDetailsComponents/Details';
import getUSStateAbbreviation from '../lib/getUSStateAbbreviation';
import Financials from '../Components/PaymentDetailsComponents/Financials';
import { Spinner } from 'react-bootstrap';
// import useGetInstitutionLogos from '../../../hooks/useGetInstitutionLogos';
import { Logo } from '../../BoxContainer/Logo';
import { useInstitutionLogo } from '../../../utils/service/service_institution_logo';

export default function PaymentDetails(props) {
  const cardContainerRef = React.useRef(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { transferId } = useParams();
  const { loadingSearchTransfer, transfer, refetchTransfer } =
    useTransfer(transferId);
  const { institutionLogo } = useInstitutionLogo(
    transfer?.sourceBankAccount?.institutionCode,
  );

  console.log(transfer);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (loadingSearchTransfer) {
    return (
      <div className={css.pageWrapper}>
        <Spinner size="80px" />
      </div>
    );
  }

  return (
    <div className={css.pageWrapper}>
      <div ref={cardContainerRef} className={css.cardContainer}>
        <div id="brand-logo" style={{ display: 'none' }}>
          <Logo
            styleOverride={{
              padding: '0px',
              marginLeft: '18px',
              marginBottom: '0px',
            }}
            brandLogo={props.tenantLogo}
          />
        </div>
        <CardHeader
          transfer={transfer}
          cardContainerRef={cardContainerRef}
          paymentId={transfer?.referenceID}
          attachments={transfer?.attachment}
        />
        <ProgressAndDollar
          completedOn={transfer?.completedOn}
          updatedOn={transfer?.updatedAt_utc}
          isLoading={loadingSearchTransfer}
          amount={transfer?.amount}
          status={transfer?.status}
        />
        <div className={css.expandableSectionsContainer}>
          <ExpandableSections
            descriptionStyle={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: '500',
              fontSize: '16px',
              marginBottom: '0px',
              marginTop: '0px',
              color: '#7368A1',
            }}
            caretSelector={'Details_Caret'}
            description="Details"
            CustomComponent={() => {
              return Details({
                notes: transfer?.notes,
                propertyInfo: {
                  street1: transfer?.propertyAddress1,
                  street2: transfer?.propertyAddress2,
                  city: transfer?.propertyCity,
                  zip: transfer?.propertyZipcode,
                  state: getUSStateAbbreviation(transfer?.propertyState),
                },
                from: transfer?.client,
                to: transfer?.tenant,
                createdOn: transfer?.updatedAt_utc,
                purpose: transfer?.purpose,
              });
            }}
            caretWidth="17px"
            caretHeight="15px"
            caretColor="#7368A1"
            customStyle={{
              marginLeft: 'auto',
              marginRight: 'auto',
              marginTop: '35px',
              marginBottom: '15px',
              backgroundColor: '#F2F4FD',
              paddingLeft: '20px',
            }}
            height="32px"
            backgroundColor="#F2F4FD"
          />
          <ExpandableSections
            caretSelector={'Financials_Caret'}
            CustomComponent={() => {
              return Financials({
                debitMethod: transfer?.debitMethod,
                srcBank: transfer?.sourceBankAccount,
                fee: transfer?.fee,
                amount: transfer?.amount,
                logoURL: institutionLogo,
                creditTraceID: transfer?.creditTraceID,
                referenceID: transfer?.referenceID,
                tenantName: transfer?.tenant?.name,
                purpose: transfer?.purpose,
              });
            }}
            descriptionStyle={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: '500',
              fontSize: '16px',
              marginBottom: '0px',
              marginTop: '0px',
              color: '#7368A1',
            }}
            description="Financials"
            caretWidth="17px"
            caretHeight="15px"
            caretColor="#7368A1"
            customStyle={{
              marginLeft: 'auto',
              marginRight: 'auto',
              marginTop: '25px',
              marginBottom: '15px',
              paddingLeft: '20px',
              backgroundColor: '#F2F4FD',
            }}
            height="32px"
            backgroundColor="#F2F4FD"
          />
        </div>
      </div>
    </div>
  );
}
